import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const ClosedBox = ({ svgSize = ICON_SIZES.MD, className = '' }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 22.6667L15.8333 28.0001V14.0001L4.5 8.66675V22.6667Z"
          fill={theme.icon.fill}
        />
        <path
          d="M15.2393 3.59271C15.727 3.39199 16.274 3.39191 16.7617 3.59271L27.5879 8.04974C27.8376 8.15264 28 8.39687 28 8.66693V21.8202C28 22.595 27.5525 23.2999 26.8516 23.6298L16.8516 28.3359C16.3123 28.5896 15.6877 28.5896 15.1484 28.3359L5.14844 23.6298C4.44766 23.2999 4 22.5948 4 21.8202V8.66693C4.00002 8.3968 4.1633 8.15259 4.41309 8.04974L10.0801 5.71673L15.2393 3.59271ZM5.33398 21.8202C5.33398 22.0785 5.48315 22.3138 5.7168 22.4238L15.333 26.9492V14.4101C15.2708 14.388 15.2088 14.3643 15.1484 14.3359L5.33398 9.71673V21.8202ZM21.9512 11.9365L16.8516 14.3359C16.7912 14.3643 16.7292 14.3881 16.667 14.4101V26.9492L26.2842 22.4238C26.5178 22.3138 26.667 22.0785 26.667 21.8202V9.71576L21.9512 11.9365ZM6.31934 8.70697L15.7168 13.1298C15.8965 13.2142 16.1045 13.2143 16.2842 13.1298L20.0596 11.3525L10.3242 7.05755L6.31934 8.70697ZM16.2539 4.82513C16.0914 4.75832 15.9086 4.75823 15.7461 4.82513L12.0332 6.35443L21.6582 10.6005L25.6816 8.70697L16.2539 4.82513Z"
          fillRule="evenodd"
          fill={theme.icon.stroke}
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8225 39.2446L28 47.8333V26.0382C28 25.8115 27.8687 25.6054 27.6633 25.5096L11.33 17.8873C10.9433 17.7069 10.5 17.9892 10.5 18.416V38.7228C10.5 38.9438 10.6248 39.1458 10.8225 39.2446Z"
        fill={theme.icon.fill}
      />
      <path
        d="M27.1885 9.31491C27.7063 9.09059 28.2937 9.09059 28.8115 9.31491L45.8477 16.6967C46.1675 16.8353 46.3748 17.1509 46.375 17.4995V38.3618C46.375 39.1351 45.9377 39.8421 45.2461 40.188L28.9131 48.3549C28.3383 48.6423 27.6617 48.6423 27.0869 48.3549L10.7539 40.188C10.0623 39.8421 9.625 39.1351 9.625 38.3618V17.4995C9.6252 17.1509 9.83251 16.8353 10.1523 16.6967L18.9023 12.9057L27.1885 9.31491ZM11.375 38.3618C11.375 38.4721 11.4375 38.5731 11.5361 38.6225L27.125 46.4165V26.2231L11.375 18.8735V38.3618ZM37.1201 22.3764L28.875 26.2231V46.4165L44.4639 38.6225C44.5625 38.5731 44.625 38.4721 44.625 38.3618V18.8735L37.1201 22.3764ZM12.6318 17.5288L27.877 24.643C27.9551 24.6794 28.0449 24.6794 28.123 24.643L34.6494 21.5971L19.2422 14.6645L12.6318 17.5288ZM28.1162 10.9204C28.0423 10.8884 27.9577 10.8884 27.8838 10.9204L21.415 13.7231L36.7432 20.6206L43.3672 17.5288L28.1162 10.9204Z"
        fillRule="evenodd"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

ClosedBox.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default ClosedBox;
